import React from 'react'
import { useRemoteData } from '../../../lib/RemoteData'
import { InstallationReference } from '../../../domain/DTO'
import { API_HOST } from '../../../lib'
import { SRD } from 'srd'
import { InstallationViewTable } from './InstallationViewTable'
import { LoadingSpinner } from '../../../components/LoadingSpinner'

type Edit = {
  commonId: string
  installationIdSource: string
}

type Props = {
  edit: Edit
  onComplete: (installationIds: string[]) => Promise<void>
}

export const InstallationViewDialog = ({ onComplete, edit }: Props) => {
  const { data: commonInstallations } = useRemoteData<InstallationReference[]>(
    `${API_HOST}/v1/common/${edit.commonId}/installations`,
  )

  const handleComplete = async (installationIdTargets: string[]) => {
    await onComplete(installationIdTargets)
  }

  return SRD.match(
    {
      notAsked: () => <LoadingSpinner />,
      loading: () => <LoadingSpinner />,
      failure: (err) => (
        <div className="alert alert-danger my-sm">
          Failed to load installations for Common
          <div>Reason: {err.body?.title}</div>
        </div>
      ),
      success: (commonInstallations) => (
        <InstallationViewTable
          installations={commonInstallations.filter(
            (installation) => installation.installationId !== edit.installationIdSource,
          )}
          onComplete={handleComplete}
        />
      ),
    },
    commonInstallations,
  )
}
